import { render, staticRenderFns } from "./CardElement.vue?vue&type=template&id=24e9c864&"
import script from "./CardElement.vue?vue&type=script&lang=js&"
export * from "./CardElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports